/**
 * Rasa Membership - Premium Keyhole Peep Intro Animation
 * File: assets/rasa-membership-keyhole.js
 */

(function () {
  'use strict';

  var KEYHOLE_INTRO = typeof window.KEYHOLE_INTRO !== 'undefined' ? window.KEYHOLE_INTRO : true;
  var PLAY_ONCE_PER_SESSION = typeof window.PLAY_ONCE_PER_SESSION !== 'undefined' ? window.PLAY_ONCE_PER_SESSION : false;

  var STORAGE_KEY = 'rasaMembershipKeyholeSeen';
  var OVERLAY_ID = 'rasa-keyhole-overlay';
  var BACKDROP_ID = 'kh-backdrop';
  var TOTAL_DURATION = 4700; // 4.3s animation + 0.4s fade = 4.7s
  var autoTimer = null;
  var isDismissed = false;

  function initKeyhole() {
    var overlay = document.getElementById(OVERLAY_ID);
    var backdrop = document.getElementById(BACKDROP_ID);

    // 1. Single flag check
    if (!KEYHOLE_INTRO) {
      cleanup(overlay, backdrop);
      return;
    }

    // 2. Prefers reduced motion check
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      cleanup(overlay, backdrop);
      return;
    }

    // 3. Shopify theme editor check
    if (window.Shopify && window.Shopify.designMode) {
      cleanup(overlay, backdrop);
      return;
    }

    // 4. Session check
    try {
      if (
        window.location.search.indexOf('view=rasa-membership') !== -1 ||
        window.location.search.indexOf('replay=1') !== -1 ||
        window.location.search.indexOf('reset_keyhole=1') !== -1
      ) {
        sessionStorage.removeItem(STORAGE_KEY);
      } else if (PLAY_ONCE_PER_SESSION && sessionStorage.getItem(STORAGE_KEY) === 'true') {
        cleanup(overlay, backdrop);
        return;
      }
    } catch (e) {}

    // Lock scrolling while peep animation runs
    document.body.classList.add('keyhole-animating');
    document.documentElement.classList.add('kh-active');
    document.body.classList.add('kh-active');

    // Reveal hero copy at 3.7s
    document.querySelectorAll('[data-kh-hold]').forEach(function (el) {
      el.style.animation = 'kh-in 1s 3.7s cubic-bezier(.2,.7,.25,1) both';
    });

    // Hero counter-zoom (scale 1.2 -> 1.14 -> 1)
    var hero = document.getElementById('kh-hero') ||
               document.querySelector('[data-kh-hero]') ||
               document.querySelector('.hero-beyond-section');
    if (hero) {
      hero.style.animation = 'kh-push 4.6s ease-in-out forwards';
      hero.style.transformOrigin = '50% 50%';
      hero.style.willChange = 'transform';
      hero.style.backfaceVisibility = 'hidden';
    }

    function dismissKeyhole() {
      if (isDismissed) return;
      isDismissed = true;

      if (autoTimer) {
        clearTimeout(autoTimer);
        autoTimer = null;
      }

      try {
        sessionStorage.setItem(STORAGE_KEY, 'true');
      } catch (e) {}

      cleanup(overlay, backdrop);

      // Clean up inline animation styles so theme scripts work normally
      if (hero) {
        hero.style.animation = '';
        hero.style.transform = '';
      }
      document.querySelectorAll('[data-kh-hold]').forEach(function (el) {
        el.style.animation = '';
        el.style.opacity = '1';
        el.style.transform = '';
      });

      // Remove skip event listeners
      window.removeEventListener('touchstart', onUserSkip);
      window.removeEventListener('touchmove', onUserSkip);
      window.removeEventListener('wheel', onUserSkip);
      window.removeEventListener('click', onUserSkip);
    }

    function onUserSkip() {
      dismissKeyhole();
    }

    // Allow user to tap, swipe or scroll to dismiss immediately and unlock scrolling on mobile & desktop
    window.addEventListener('touchstart', onUserSkip, { passive: true });
    window.addEventListener('touchmove', onUserSkip, { passive: true });
    window.addEventListener('wheel', onUserSkip, { passive: true });
    window.addEventListener('click', onUserSkip, { passive: true });

    // Overlay cleanup & enable scroll after 4.7s automatically
    autoTimer = setTimeout(dismissKeyhole, TOTAL_DURATION);
  }

  function cleanup(overlay, backdrop) {
    if (overlay && overlay.parentNode) {
      overlay.style.display = 'none';
      overlay.parentNode.removeChild(overlay);
    }
    if (backdrop && backdrop.parentNode) {
      backdrop.style.display = 'none';
      backdrop.parentNode.removeChild(backdrop);
    }
    document.body.classList.remove('keyhole-animating');
    document.body.classList.remove('kh-active');
    document.documentElement.classList.remove('kh-active');
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKeyhole);
  } else {
    initKeyhole();
  }
})();
